import React from "react";

import { FormControl, FormHelperText, TextField } from "@mui/material";

const TiktokAppIdField = ({ value, error, language, onChange }) => (
    <FormControl
        className="mb-3"
        style={{ width: "100%" }}
        error={Boolean(error)}
    >
        <TextField
            name="tt_app_id"
            inputProps={{ "data-cy": "create-destination-app-id" }}
            label="App ID"
            variant="outlined"
            onChange={onChange}
            value={value || ""}
            placeholder="App ID"
            error={Boolean(error)}
        />
        {error && (
            <FormHelperText>
                {language?.source_modal?.validation_error ?? "Validation Error"}
            </FormHelperText>
        )}
    </FormControl>
);

export default TiktokAppIdField;
